(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/components/link-button.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/components/link-button.js');
"use strict";


const LinkButton = _ref => {
  let children = _ref.children,
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '' : _ref$href,
    onClick = _ref.onClick,
    className = _ref.className;
  return React.createElement("a", {
    className: "payfooter-link ".concat(className),
    href: href,
    onClick: onClick
  }, children);
};
svs.tur.ReactPayfooter.LinkButton = LinkButton;

 })(window);